var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"fl-te-c-res py-3 px-3 border-r-1 line-bottom-100"},[_c('notification-card',{attrs:{"data":_vm.data}}),_c('div',{staticClass:"b-1 px-3 py-2 border-r-3 text-center font-inter-light"},[_vm._v(_vm._s(_vm.getTimeLeft()))])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }